module.exports = __webpack_public_path__ + "media/customizations/valencia/logo-eae31adf31814e747c2525f91c272f73.png";